// @/services/ChaptersClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const chaptersOptions = {
  baseUrl: `${BACK_END_URL}/chapter`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class ChaptersClient extends CandyClient {
  constructor() {
    super(chaptersOptions);
  }

  // Get single chapter by ID
  async getChapterById(id) {
    return this.get(`/id/${id}`);
  }

  // Get all chapters for a course
  async getAllChaptersByCourse(courseId) {
    return this.get(`/list/${courseId}`);
  }

  // Create a new chapter (requires auth)
  async createChapter(dto) {
    return this.post(`/create`, dto, {
      customHeaders: { 
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }   
    });
  }

  // Update a chapter (requires auth)
  async updateChapter(id, dto) {
    return this.put(`/update/${id}`, dto, {
      customHeaders: { 
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }   
    });
  }

  // Delete a chapter (requires auth)
  async deleteChapter(id) {
    return this.delete(`/delete/${id}`, null, {
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  }

  // Get prerequisites for a chapter
  async getPrerequisites(chapterId) {
    return this.get(`/${chapterId}/prereq`);
  }

  // Add a prerequisite to a chapter
  async addPrerequisite(chapterId, prerequisiteData) {
    return this.post(`/${chapterId}/prereq`, prerequisiteData, {
      customHeaders: { 
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }

  // Update a prerequisite for a chapter
  async updatePrerequisite(chapterId, prerequisiteId, updateData) {
    return this.put(`/${chapterId}/prereq/${prerequisiteId}`, updateData, {
      customHeaders: { 
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }

  // Delete a prerequisite from a chapter
  async deletePrerequisite(chapterId, prerequisiteId) {
    return this.delete(`/${chapterId}/prereq/${prerequisiteId}`, null, {
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  }

  async reorderChapters(dto) {
    const response = await fetch(`${BACK_END_URL}/chapter/reorder`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(dto),
    });

    const text = await response.text();
    return text ? JSON.parse(text) : null;
  }

  // Reorder units (lessons, quizzes, etc.)
  async reorderUnits(dto) {
    const response = await fetch(`${BACK_END_URL}/unit/reorder`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(dto),
    });

    const text = await response.text();
    return text ? JSON.parse(text) : null;
  }
}